import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';
import {Routes, Route} from 'react-router-dom';

import classes from './Main.module.css';

import NavBar from '@components/NavBar/NavBar';
import Footer from '@components/Footer/Footer';

import AboutUs from "./AboutUs/AboutUs";
import VisionMissions from "./VisionMissions/VisionMissions";
import PastEvents from "./PastEvents/PastEvents";
import Partnerships from "./Partnerships/Partnerships";
// import Courses from './Courses/Courses';
import Foundation from "./Foundation/Foundation";
import Regular from "./Regular/Regular";
import EliteSchools from "./EliteSchools/EliteSchools";
import EnglishSpeaking from "./EnglishSpeaking/EnglishSpeaking";
import GroupDiscussion from "./GroupDiscussion/GroupDiscussion";
import AdmissionTalk from "./AdmissionTalk/AdmissionTalk";
import Bridging from "./Bridging/Bridging";
import Timetable from "./Timetable/Timetable";
import Application from "./Application/Application";
import ContactUs from "./ContactUs/ContactUs";
import Home from './Home/Home';
import Error404 from '../Error404/Error404';
import ImpDates from './ImpDates/ImpDates';
import OnSite from './OnSite/OnSite';
//import Test from '../TestPage/TestPage'



const Main = (props) => {

    const[marginSize, setMarginSize] = useState("100px");
    
    const listenScrollEvent = () => {
        window.scrollY > 6 ? setMarginSize("80px") : setMarginSize("100px");
    }

    useEffect(() => {
        window.addEventListener("scroll", listenScrollEvent);
        return () => {
            window.removeEventListener("scroll", listenScrollEvent);
        };
    }, []);

    return (
        <React.Fragment>
            {ReactDOM.createPortal(<NavBar/>, document.getElementById("navbar-root"))}
            <div 
                    className={classes.Pages}
                    style={{
                        marginTop: marginSize,
                         transition: "all 1s"
                }}>
                
                <Routes>
                    <Route path='/about-us' element={<AboutUs/>}/>
                    <Route path='/vision-missions' element={<VisionMissions/>}/>
                    <Route path='/past-events' element={<PastEvents/>}/>
                    <Route path='/partnerships' element={<Partnerships/>}/>
                    {/* <Route path='/courses' element={<Courses/>}/> */}
                    <Route path='/foundation' element={<Foundation/>}/>
                    <Route path='/regular' element={<Regular/>}/>
                    <Route path='/elite-schools' element={<EliteSchools/>}/>
                    <Route path='/english-speaking' element={<EnglishSpeaking/>}/>
                    <Route path='/group-discussion' element={<GroupDiscussion/>}/>
                    <Route path='/f1-admission-talk' element={<AdmissionTalk/>}/>
                    <Route path='/f1-bridging' element={<Bridging/>}/>
                    <Route path='/timetable' element={<Timetable/>}/>
                    <Route path='/application' element={<Application/>}/>
                    <Route path='/contact-us' element={<ContactUs/>}/>
                    <Route path='/information' element={<ImpDates/>}/>
                    <Route path='/important-dates' element={<ImpDates/>}/>
                    <Route path='/onsite' element={<OnSite/>}/>
                    <Route path='/' element={<Home/>}/>
                    <Route path='*' element={<Error404 link="/"/>}/>
                </Routes>
            </div>
            <Footer/>
        </React.Fragment>
    );
};

export default Main;